import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import { buildValidations } from 'umg-ember-backend/utils/validations';

// Needed for belongs-to validation
const Validations = buildValidations();

export default class NewsletterTargetModel extends Model.extend(Validations) {
  @attr('boolean', { defaultValue: false }) dataSharing;
  @attr('string') group;
  @attr('string') language;
  @attr('string') name;
  @attr('number') target;
  @attr('string') type;
  @belongsTo('organization', { async: true, inverse: null }) legalContext;

  // Getter and setter
  get displayLabel() {
    return this.name;
  }
}
